import { IApplicationState } from '../../types/redux';

export const selectIsSubmittedAnketaModalOpen = (state: IApplicationState): boolean =>
  state.calculator.submittedAnketaModal.isOpen;
